/* Vela Nine — headline reveal.
   Each heading is split into words that rise from behind a mask as the section
   comes into view. Sober by intent: one gesture, one direction, no bounce.
   Skipped entirely for visitors who ask for reduced motion, and skipped for
   any heading that contains markup so nothing is destroyed. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = [
    '.vn-hero__title',
    '.vn-h2',
    '.vn-split__title',
    '.vn-manifesto__title',
    '.vn-page-title',
    '.vn-promo__headline'
  ].join(',');

  function split(el) {
    if (el.dataset.vnSplit) return false;
    // Only plain text is safe to rebuild.
    if (el.children.length) return false;
    var text = el.textContent.trim();
    if (!text) return false;

    el.dataset.vnSplit = '1';
    el.textContent = '';

    // The hero headline is the signature of the page, so it is given a wider
    // stagger and lets the eyebrow land first. Section titles stay brisker.
    var hero = el.classList.contains('vn-hero__title');
    var step = hero ? 90 : 55;
    var base = hero ? 200 : 0;

    text.split(/\s+/).forEach(function (word, i) {
      var mask = document.createElement('span');
      mask.className = 'vn-word';
      var inner = document.createElement('span');
      inner.className = 'vn-word__i';
      inner.textContent = word;
      inner.style.transitionDelay = base + i * step + 'ms';
      mask.appendChild(inner);
      el.appendChild(mask);
      el.appendChild(document.createTextNode(' '));
    });
    return true;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        // A frame of daylight so the hidden state has painted; without it an
        // element already on screen at load would jump straight to its end
        // state with no transition at all.
        requestAnimationFrame(function () {
          entry.target.classList.add('is-revealed');
        });
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (split(el)) observer.observe(el);
    });
  }

  // Safety net. These words start invisible, so anything that stops the
  // observer firing — a stray error, an odd viewport, a browser quirk — would
  // erase the copy permanently. After a while, reveal whatever is left
  // regardless. Invisible text is never an acceptable failure.
  setTimeout(function () {
    document.querySelectorAll('[data-vn-split]:not(.is-revealed)').forEach(function (el) {
      el.classList.add('is-revealed');
    });
  }, 8000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
